export default __webpack_public_path__ + "static/media/logo_alt_small.0df87f64.xcf";